import type { SchemaField, SchemaFilter } from '@cli-types/core-engine/schema.js'
import { FILTERABLE_FIELD_TYPES } from '@cli-constants/schema-codegen.js'

export function ensureFilterableField(
  field: SchemaField | undefined,
  filter: SchemaFilter,
  schemaName: string
): SchemaField {
  if (!field) {
    throw new Error(
      `Schema "${schemaName}" defines a filter for "${filter.field}", but that field does not exist.`
    )
  }

  if (!FILTERABLE_FIELD_TYPES.has(field.type)) {
    throw new Error(
      `Schema "${schemaName}" defines a filter for "${filter.field}", but "${field.type}" fields are not filterable.`
    )
  }

  return field
}
